var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7071 5.29297C11.0976 5.68349 11.0976 6.31666 10.7071 6.70718L6.41396 11.0003H20C20.5523 11.0003 21 11.448 21 12.0003C21 12.5526 20.5523 13.0003 20 13.0003H6.41446L10.7071 17.293C11.0976 17.6835 11.0976 18.3167 10.7071 18.7072C10.3166 19.0977 9.68342 19.0977 9.29289 18.7072L3.30545 12.7197C3.12972 12.55 3.016 12.3166 3.00159 12.0566C2.99799 11.9925 3.00051 11.9282 3.00917 11.8646C3.01346 11.8329 3.01924 11.8017 3.02643 11.7711C3.06747 11.5959 3.15629 11.4296 3.29289 11.293L9.29289 5.29297C9.68342 4.90245 10.3166 4.90245 10.7071 5.29297Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.35ca09906719b1cb8dd72601ec6e0fee.svg";
export { ForwardRef as ReactComponent };